import { useTranslation } from "next-i18next";

import { SORT_OPTIONS, useSort } from "@/features/search/hooks/useSort";
import { RadioButton } from "@/ui/cva/radio-button/RadioButton";

/**
 * Sort inside the mobile filter panel — the same options as `SortSelect`, as a radio group, so it
 * reads like the facets it sits above rather than like a control borrowed from the desktop row.
 *
 * Rows deliberately match `ChoiceFacet`'s markup. Unlike a facet, picking the selected option again
 * doesn't clear it: there is no "unsorted", relevance *is* the default, and it has its own row.
 */
export const SortRadioGroup = () => {
  const { t } = useTranslation();
  const { pending, current, select } = useSort();

  return (
    <fieldset
      disabled={pending}
      className="m-0 flex min-w-0 flex-col border-0 p-0"
    >
      <ul className="flex flex-col space-y-2">
        {SORT_OPTIONS.map(option => (
          <li key={option.id}>
            <label className="flex cursor-pointer items-center space-x-2 font-body text-sm">
              <RadioButton
                name="sort"
                value={option.id}
                checked={option.id === current}
                onChange={() => select(option.id)}
              />
              <span className="text-black">{t(option.labelKey)}</span>
            </label>
          </li>
        ))}
      </ul>
    </fieldset>
  );
};
